import { observer } from 'mobx-react-lite'
import { RecordAudioModal } from 'widgets/RecordAudio'
import type { RinglessMessageFieldStore } from 'widgets/MessageFormFields/RinglessMessageField/store/ringlessMessageFieldStore'

type IProps = {
  store: RinglessMessageFieldStore
}

export const RinglessRecordAudioModal = observer(({ store }: IProps) => (
  <RecordAudioModal recordAudioStore={store.recordAudioStore} onInit={store.initRecordAudio} />
))
